import { Stack, Typography } from "@mui/material"
import { memo, useMemo } from "react"
import { Icon } from "../../../../muiStyled/DataDisplay/Icons"
import { useDefaultArticleItemState } from "../../ContextProviderStates/DefaultArticleItemState"
import { useWholesalerArticleItemState } from "../../ContextProviderStates/WholesalerArticleItemState"
import { WholesalerErpContainer } from "../../ErpContainer"
import { ImageContainer, TileWrapper } from "../../StyledComponents"
import { AddToBasket } from "../../Transactions/AddToBasket"

export const TileArticleContentComponent = memo(() => {
    const articleErpInfo = useWholesalerArticleItemState((x) => x.articleErpInfos?.default)
    const quantity = useWholesalerArticleItemState((x) => x.quantity)
    const addToBasketButtonDisabled = useWholesalerArticleItemState((x) => x.addToBasketButtonDisabled)
    const division = useMemo(() => (articleErpInfo?.state === "success" ? articleErpInfo.response.quantity?.division : 1) || 1, [articleErpInfo])
    const basketQuantity = useWholesalerArticleItemState((x) => x.basketQuantity?.articleQuantities?.totalQuantity)
    const handleChangeQuantity = useWholesalerArticleItemState((x) => x.handleChangeQuantity)
    const handleRemoveFromBasket = useWholesalerArticleItemState((x) => x.handleRemoveFromBasket)
    const handleAddToBasket = useWholesalerArticleItemState((x) => x.handleAddToBasket)
    const article = useWholesalerArticleItemState((x) => x.article)
    const additionalInformation =
        article.additionalInformationExtended || (articleErpInfo?.state === "success" ? articleErpInfo?.response?.additionalInformation : undefined)
    const expanded = useDefaultArticleItemState((x) => x.expanded)
    const articleOrder = useDefaultArticleItemState((x) => x.articleOrder)

    return useMemo(() => {
        return (
            <TileWrapper expanded={expanded} order={articleOrder || 0}>
                <Stack spacing="0.5em">
                    {/* Article Image */}
                    <Stack alignItems="center">
                        <ImageContainer imageStylings={{ size: 140, marginTop: 1, boxShadow: "none" }}>
                            <Icon name="supplier" sx={{ fontSize: 140 }} />
                        </ImageContainer>
                    </Stack>
                    <Stack flexDirection="row" alignItems="end" justifyContent="space-between">
                        <Stack alignItems="start" height="70px" maxWidth="calc(100% - 30px)" paddingLeft="0.5rem">
                            <Typography sx={{ color: "primary.main", fontWeight: "bold" }}>{article.wholesalerArticleNumber}</Typography>
                            <Typography>{additionalInformation}</Typography>
                        </Stack>
                    </Stack>
                </Stack>
                {/* ERP Infos */}
                <Stack spacing={2}>
                    <>
                        <WholesalerErpContainer />
                        <AddToBasket
                            originalQuantity={quantity}
                            division={division}
                            basketQuantity={basketQuantity}
                            onAddToBasket={handleAddToBasket}
                            onChangeQuantity={handleChangeQuantity}
                            onRemoveFromBasket={handleRemoveFromBasket}
                            disableButton={addToBasketButtonDisabled}
                            compactView
                        />
                    </>
                </Stack>
            </TileWrapper>
        )
    }, [
        addToBasketButtonDisabled,
        additionalInformation,
        article.wholesalerArticleNumber,
        articleOrder,
        basketQuantity,
        division,
        expanded,
        handleAddToBasket,
        handleChangeQuantity,
        handleRemoveFromBasket,
        quantity,
    ])
})
